import type { AppState } from '@xuwo/drawing/types';

import { getSelectedElementsByGroup } from './groups';
import { isNonDeletedElement } from './index';
import { getBoundTextElement } from './textElement';
import { isFrameLikeElement } from './typeChecks';
import type { ElementsMap, NonDeletedExcalidrawElement } from './types';

/** Frames are arrangement units: their bounds drive alignment, their children travel with them. */
export const getArrangementGroups = (
  selected: NonDeletedExcalidrawElement[],
  elementsMap: ElementsMap,
  appState: Readonly<Pick<AppState, 'selectedGroupIds' | 'editingGroupId'>>
) => {
  const frames = new Set(
    selected.filter(isFrameLikeElement).map(element => element.id)
  );
  const roots = selected.filter(
    element => !element.frameId || !frames.has(element.frameId)
  );
  return getSelectedElementsByGroup(roots, elementsMap, appState).map(
    boundsElements => {
      const elements = new Map(
        boundsElements.map(element => [element.id, element])
      );
      const groupFrames = new Set(
        boundsElements.filter(isFrameLikeElement).map(element => element.id)
      );
      if (groupFrames.size) {
        for (const element of elementsMap.values()) {
          if (
            isNonDeletedElement(element) &&
            element.frameId &&
            groupFrames.has(element.frameId)
          ) {
            elements.set(element.id, element);
            const text = getBoundTextElement(element, elementsMap);
            if (text && isNonDeletedElement(text)) elements.set(text.id, text);
          }
        }
      }
      return { boundsElements, elements: [...elements.values()] };
    }
  );
};
